import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CuttingMasterService extends GenericService {
  constructor() {
    super('/cutting_masters', axiosInstance);
  }
}

export default new CuttingMasterService();